import { type FC } from 'react';
import {
  Translate
} from '@phosphor-icons/react';
import { UiIcon, type UiIconProps } from './UiIcon';

export type UiIconTranslateProps = Omit<UiIconProps, 'IconComponent'>;

export const UiIconTranslate: FC<UiIconTranslateProps> = (props) => {
  return (
    <UiIcon
      IconComponent={Translate}
      {...props}
    />
  );
};
